<template>
  <div class="yellow-post">
      <a href="https://www.youtube.com/channel/UCGPn3PDaWP5Z8tNaUWAo1PA" >
          <img class="banner-youtube" src="../assets/banner-mobile.gif">
      </a>
  </div>
</template>
<script>
export default {
  name: 'Banner',
  props: {
    title: String,
  }
}
</script>
<style>
.yellow-post {
    background-color: #F4BC0B;
    transition: all 0.3s ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 480px;
    z-index: 1;
}

.yellow-post a {
  padding: 20px!important;
}

.banner-youtube{
    max-width: 100%;
    height: auto;
}

.yellow-post:hover {
    background-color: #ffffff;
    box-shadow: 0px 0px 60px 1px rgba(131,128,122,0.39);
    transition: all 0.3s ease-in-out;
    z-index: 1;
    cursor: pointer;
}
@media only screen and (max-width:1255px){
    .img-aliados{
        height: 120px;
        padding: 10px;
    }
}


@media only screen and (max-width: 1150px){

    .menu{
        display: none;
    }
    .res-menu{
        display: inline !important;
        font-size: 30px;
        padding-top: 10px;
        cursor: pointer;
    }

}

@media only screen and (max-width: 640px){

    .logo-text {
        width: 62px;
        font-family: Raleway;
        font-style: normal;
        font-weight: bold;
        font-size: 10px;
        line-height: 11px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding-left: 9px;
        padding-top: 11px;
    }

    .search {
        width: 160px;
    }

    .title-about{
        width: 100%;
        font-size: 25px;
    }

    .about-afu{
        width: 100%;
        height: 380px;
    }
    .card-post{
        height: auto;
    }
    .img-gradient, .card-post-img-2{
        height: 180px;
    }


    .yellow{
        width: 100% !important;
    }
    .home-slider{
        width: 100%;
        height: auto;
    }
    .slideshow-container {
        height: auto !important;
    }
    .img-aliados{
        height: 90px;
        padding: 1px;
    }
    .footer-container{
        padding-left: 40px;
        flex-direction: column;
    }
    footer{
        height: auto;
    }
}
</style>
